import request from '@/utils/request'

//  交易准备
export function orderPrepare(data) {
  return request({
    url: 'product/order/prepare',
    method: 'post',
    data: data,
  })
}
// 创建订单
export function orderCreatePayment(data) {
  return request({
    url: 'product/order/create-payment',
    method: 'post',
    data: data,
  })
}
// 小程序订单创建
export function mpOrderCreatePayment(data) {
  return request({
    url: 'mpcourse/api/mp/v1/order/create-payment',
    method: 'post',
    data: data,
  })
}

// 检查支付完成
export function checkPaymentResult(data) {
  return request({
    url: 'product/order/check-payment-result',
    method: 'post',
    data: data,
  })
}

// 添加免费商品
// item_no
// type: course | questionset
export function addFreeVirtualGoods(data) {
  return request({
    url: 'product/order/add-free-virtual-goods',
    method: 'post',
    data: data,
  })
}
// 优惠券
export function ordercoupons(data) {
  return request({
    url: 'product/coupons/getList',
    method: 'post',
    data: data,
  })
}
// 获取客服
export function orderservic(data) {
  return request({
    url: 'product/home/index',
    method: 'post',
    data: data,
  })
}

// 获取支付信息
export function getMpJsapiPayInfo(data) {
  return request({
    url: '/product/order/get-pay-info',
    method: 'post',
    data: data,
  })
}
// 获取订单信息
export function getMpJsapiOrderInfo(data) {
  return request({
    url: '/product/order/get-order-info',
    method: 'post',
    data: data,
  })
}
